import { View, Dialog } from "../base";
import { RegionSettingsForm, RegionSettingsFormData } from "./RegionSettingsForm";

type RegionSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: RegionSettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const RegionSettingsDialog = ({ isOpen, onClose, config, onChange }: RegionSettingsDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Region Settings"
      size="flex"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      <View className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
        <RegionSettingsForm
          config={config}
          onChange={onChange}
        />
      </View>
      <View className="flex items-center justify-end p-4 gap-4 border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          onClick={onClose}
          className="flex flex-row items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-sm font-medium transition-colors border bg-gray-50 dark:bg-gray-800 text-gray-600 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
        >
          Close
        </button>
      </View>
    </Dialog>
  );
};
